var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(0, 0, 0, 0) none repeat scroll 0% 0%",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 10,
    height: 40,
    fill: "#00aeef"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    values: "1;0.2;1",
    begin: -0.6
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 30,
    width: 10,
    height: 40,
    fill: "#ddf6ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    values: "1;0.2;1",
    begin: -0.4
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 30,
    width: 10,
    height: 40,
    fill: "#62bb46"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    values: "1;0.2;1",
    begin: -0.2
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 30,
    width: 10,
    height: 40,
    fill: "#e4f4df"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    values: "1;0.2;1",
    begin: -1
  }))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/small.b85d1176763626cc444d4f80a4a94d16.svg";